import React from 'react';

export const TikTokIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5285_4472)">
        <path
          d="M13.1703 2.5H10.6424V12.7174C10.6424 13.9348 9.67012 14.9348 8.46016 14.9348C7.25021 14.9348 6.27793 13.9348 6.27793 12.7174C6.27793 11.5217 7.22861 10.5435 8.39536 10.5V7.93479C5.8242 7.97825 3.75 10.087 3.75 12.7174C3.75 15.3696 5.86741 17.5 8.48178 17.5C11.0961 17.5 13.2135 15.3478 13.2135 12.7174V7.47825C14.1642 8.17392 15.3309 8.58696 16.5625 8.60871V6.04348C14.6612 5.97826 13.1703 4.41304 13.1703 2.5Z"
          fill="#9075D1"
        />
      </g>
      <defs>
        <clipPath id="clip0_5285_4472">
          <rect width="15" height="15" fill="white" transform="translate(2.5 2.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
